/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_Error_City_RequiredInputs */



/**
* | output |
* | --- |
* | "City is required for in-person tournaments" |
*
* @param {Tournament_New_Error_City_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_error_city_required = /** @type {((inputs?: Tournament_New_Error_City_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Error_City_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La ville est obligatoire pour les tournois en présentiel")
	if (locale === "es") return /** @type {LocalizedString} */ ("La ciudad es obligatoria para los torneos presenciales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A cidade é obrigatória para torneios presenciais")
	if (locale === "it") return /** @type {LocalizedString} */ ("La città è obbligatoria per i tornei in presenza")
	return /** @type {LocalizedString} */ ("City is required for in-person tournaments")
});